export const productsColumns = [
  {
    id: 1,
    title: '',
    className: 'id',
  },
  {
    id: 2,
    title: 'Товар',
    className: 'name',
  },
  {
    id: 3,
    title: 'Цена поставки',
    className: 'price-of-purchase',
  },
  {
    id: 4,
    title: 'Количество',
    className: 'count',
  },
  {
    id: 5,
    title: 'Сумма',
    className: 'total-price',
  },
  {
    id: 6,
    title: '',
    className: 'delete',
  },
];

export const goodsWriteOffColumns = [
  {
    id: 1,
    title: '',
    className: 'id',
  },
  {
    id: 2,
    title: 'Товар',
    className: 'write-off_name',
  },
  {
    id: 3,
    title: 'Поставщик',
    className: 'write-off_supplier',
  },
  {
    id: 4,
    title: 'Количество',
    className: 'write-off_count',
  },
  {
    id: 5,
    title: '',
    className: 'write-off_delete',
  },
];
